// src/redux/sagas/restaurantSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { request } from '../../api/request';
import { buildRestaurantUrl } from '../../utils/domainUtils';
import { getRestaurantId, setRestaurantId } from '../../api/tokenUtils';
import { Restaurant } from '../../types/restaurant';
import {
  fetchRestaurantsRequest,
  fetchRestaurantsSuccess,
  fetchRestaurantsFailure,
  selectRestaurant,
} from '../slices/restaurantSlice';
import { checkAndValidateEditControl } from '../../utils/editControlUtils';
import { fetchSiteContentRequest } from '../slices/siteContentSlice';
import { shouldSkipApiCalls } from '../../utils/appConfig';
function* fetchRestaurantsSaga(): Generator<
  unknown,
  void,
  AxiosResponse<Restaurant[]>
> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const savedRestaurantId = getRestaurantId();
    const url = buildRestaurantUrl();
    const response = yield call(request<Restaurant[]>, {
      method: 'GET',
      url,
      requiresRestaurantId: false,
    });
    const restaurantsList = response?.data;
    yield put(fetchRestaurantsSuccess(restaurantsList));
    if (!savedRestaurantId && restaurantsList?.length === 1) {
      const singleRestaurant = restaurantsList[0];
      if (singleRestaurant?.restaurant_id) {
        setRestaurantId(singleRestaurant?.restaurant_id);
        yield put(selectRestaurant(singleRestaurant?.restaurant_id));
        
        // Auto-selection case: fetch site content for single restaurant
        yield put(fetchSiteContentRequest());
        
        // Validate edit control after auto-selecting single restaurant
        checkAndValidateEditControl(singleRestaurant.restaurant_id);
      }
    }
    // Removed auto-selection of saved restaurant to ensure location selector always shows
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error?.message : 'Failed to fetch restaurants';
    yield put(fetchRestaurantsFailure(errorMessage));
  }
}



export function* watchRestaurantSaga() {
  yield takeEvery(fetchRestaurantsRequest.type, fetchRestaurantsSaga);
}
